import { WS_ID_WS } from './regex';

export const getValidId = (id: string) => {
  const match = WS_ID_WS.exec(id);
  return match?.[1] ?? '';
};
